module.exports = __webpack_public_path__ + "img/bank.984c9f6a.png";